import React, { useEffect, useState } from 'react';
import {
  useParams,
} from 'react-router-dom';

import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';

import { env } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import FormSchool from '../../forms/FormSchool.jsx';
import ModalSchDelConfirm from '../../modals/ModalSchDelConfirm.jsx';

const PageSchoolEdit = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();
  const [delRes, delReq] = useHttpStatus();
  const [title, setTitle] = useState();
  const [modalShow, setModalShow] = useState(false);

  const api = 'api/core/schools';

  useEffect(() => {
    req({
      url: `${api}/${_id}`,
    });
  }, [_id]);

  return (
    <PageHttp res={res}>
      {(doc) => {
        const t = title || doc.title;
        const breadcrumb = [
          { to: '../../', children: 'Schools' },
          { to: '../', children: t.en || t.zhhk },
        ];

        return (
          <>
            <Header breadcrumb={breadcrumb}>Edit</Header>
            <FormSchool
              school={doc}
              onSubmit={(values) => {
                setTitle(values.title);

                return values;
              }}
            />
            <hr/>
            <div className="form-group">
              <FormHttpBtn
                res={delRes}
                icon={faTrash}
                className="btn btn-danger"
                onClick={() => setModalShow(true)}
              >
                Delete
              </FormHttpBtn>
            </div>
            <ModalSchDelConfirm
              show={modalShow}
              onReject={() => setModalShow(false)}
              onConfirm={async () => {
                setModalShow(false);
                await delReq({
                  url: api,
                  method: 'delete',
                  data: { _id: doc._id },
                });
              }}
            />
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchoolEdit;
